import { createStore } from 'vuex'

export default createStore({
  state: {
    utm: {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_content: null,
      utm_term: null,
    }
  },
  getters: {
    utm: (state) => state.utm
  },
  mutations: {
    setUtm(state, params) {
      return state.utm[params.type] = params.items
    }
  },
  actions: {

  },
})
